import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const ThumbnailSkeleton = ({ arrayLength, rowCount, className, skeletonClassName, skeletonContainerClassName }) => {
  return (
    [...Array(rowCount)].map((_, rowIndex) => (
      <div className={className} key={rowIndex}>
        {[...Array(arrayLength)].map((_, index) => (
          <Skeleton key={index} className={skeletonClassName} containerClassName={skeletonContainerClassName} />
        ))}
      </div>
    ))
  );
};

ThumbnailSkeleton.propTypes = {
  arrayLength: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  skeletonClassName: PropTypes.string.isRequired,
  skeletonContainerClassName: PropTypes.string.isRequired
};

export default ThumbnailSkeleton;